// extracted by mini-css-extract-plugin
module.exports = {"inner":"Success_inner__3D97a","button":"Success_button__3pEFb"};